import PropTypes from 'prop-types';
import React, { MutableRefObject } from 'react';
import styled from 'styled-components';
import { CardLinkButton } from './Button';
import DeprecatedTooltip from './Tooltip';
import TriggerPopover from './TriggerPopover';
import HintIcon from './HintIcon';

const OverviewTitle = styled.div`
  padding: 16px 16px 8px 16px;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  color: ${(props) => props.theme.colors.inputLabel};
`;

type IOverviewCardSubTitleProps = {
  title: string;
  linkTabId?: string;
  linkTabLabel?: string;
  tabPanelRef?: MutableRefObject<any>;
  hint?: string;
};

const OverviewCardSubTitle = ({ title, linkTabId, linkTabLabel, tabPanelRef, hint }: IOverviewCardSubTitleProps) => {
  let titleElement;
  if (linkTabId) {
    titleElement = (
      <OverviewTitle>
        <div style={{ justifyContent: 'left' }}>
          {title}
          <HintIcon hint={hint} />
        </div>
        {tabPanelRef ? (
          <CardLinkButton onClick={() => tabPanelRef.current.setActiveTabId(linkTabId)}>{linkTabLabel}</CardLinkButton>
        ) : null}
      </OverviewTitle>
    );
  } else {
    titleElement = (
      <OverviewTitle>
        {title} <HintIcon hint={hint} />
      </OverviewTitle>
    );
  }

  if (hint) {
    return (
      <TriggerPopover
        flexBox={false}
        popover={<DeprecatedTooltip value={hint} style={{ top: '0px', left: '1.25rem', marginTop: '38px' }} />}
        styles={{ width: '100%' }}
      >
        {titleElement}
      </TriggerPopover>
    );
  }
  return titleElement;
};

OverviewCardSubTitle.propTypes = {
  title: PropTypes.string,
  linkTabLabel: PropTypes.string,
  linkTabId: PropTypes.string,
};

OverviewCardSubTitle.defaultProps = {
  title: '',
};

export default OverviewCardSubTitle;
